// import "./Process.css";

import SectionTitle from "./common/SectionTitle";

const processSteps = [
	{
		id: 1,
		icon: "fas fa-lightbulb",
		title: "Discovery",
		description:
			"We analyze your requirements and business objectives to understand your needs.",
		color: "#4F46E5", // indigo-600
	},
	{
		id: 2,
		icon: "fas fa-pencil-ruler",
		title: "Planning",
		description:
			"Our team creates a detailed project roadmap with milestones and deliverables.",
		color: "#10B981", // emerald-500
	},
	{
		id: 3,
		icon: "fas fa-code",
		title: "Development",
		description:
			"We build your solution using agile methodologies with regular progress updates.",
		color: "#F59E0B", // amber-500
	},
	{
		id: 4,
		icon: "fas fa-vial",
		title: "Testing",
		description:
			"Rigorous quality assurance ensures your solution meets all specifications.",
		color: "#EF4444", // red-500
	},
	{
		id: 5,
		icon: "fas fa-rocket",
		title: "Deployment",
		description:
			"We launch your solution and provide comprehensive training and documentation.",
		color: "#8B5CF6", // violet-500
	},
	{
		id: 6,
		icon: "fas fa-sync-alt",
		title: "Maintenance",
		description:
			"Ongoing support and updates keep your solution performing at its best.",
		color: "#3B82F6", // blue-500
	},
];

const Process = () => {
	return (
		<section className="process">
			<div className="container">
				<SectionTitle
					title="Our Process"
					subtitle="A structured approach to delivering exceptional results"
				/>

				<div className="process-timeline">
					{processSteps.map((step, index) => (
						<div key={step.id} className="process-step">
							<div
								className="step-icon-container"
								style={{
									backgroundColor: `${step.color}20`,
									borderColor: step.color,
								}}
							>
								<i className={step.icon} style={{ color: step.color }}></i>
							</div>

							<div className="step-content">
								<h3>{step.title}</h3>
								<p>{step.description}</p>
								<span className="step-number">{index + 1}</span>
							</div>
						</div>
					))}

					<div className="process-line"></div>
				</div>
			</div>
		</section>
	);
};

export default Process;
